import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuardOut } from './guards/guard-out.guard';

const routes: Routes = [
  { path: '', canActivate: [GuardOut], loadChildren: () => import('./components/pages/login/login.module').then(m => m.LoginModule) },
  { path: 'auth', loadChildren: () => import('./auth_layout/auth.module').then(m => m.AuthModule) },
  { path: 'register', loadChildren: () => import('./register/register.module').then(m => m.RegisterModule) },
  { path: 'login', canActivate: [GuardOut], loadChildren: () => import('./components/pages/login/login.module').then(m => m.LoginModule) },
  { path: 'login-candidate-agent', canActivate: [GuardOut], loadChildren: () => import('./components/pages/login-candidate-agent/login.module').then(m => m.LoginModule) },
  { path: 'create-password', loadChildren: () => import('./components/pages/create-password/create-password.module').then(m => m.CreatePasswordModule) },
  { path: 'otp', loadChildren: () => import('./components/pages/otp-page/otp-page.module').then(m => m.OtpPageModule) },
  { path: 'otp-candidate-agent', loadChildren: () => import('./components/pages/otp-page-candidate-agent/otp-page.module').then(m => m.OtpPageModule) },
  { path: 'doa', loadChildren: () => import('./components/pages/ondoa-page/doa-page.module').then(m => m.DoaPageModule) },
  { path: 'upload-appeal', loadChildren: () => import('./components/pages/upload-appeal-page/upload-appeal-page.module').then(m => m.UploadAppealPageModule) },
  { path: 'register-new', loadChildren: () => import('./components/pages/register/register.module').then(m => m.RegisterModule) },
  { path: 'onboarding-candidate-agent', loadChildren: () => import('./components/pages/onboarding-candidate-agent/onboarding-candidate-agent.module').then(m => m.OnboardingCandidateAgentModule) },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [
    // RouterModule.forRoot(routes),
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
